module.exports = __webpack_public_path__ + "static/media/sharpLeft.42a954c5.svg";